const FactsCard = ({catfacts}) => {
    return ( 
        <div>
            <p>{catfacts}</p>
        </div>
     );
}
 
export default FactsCard;